import React from 'react';
import appInsights from '../appInsights';

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        if (appInsights) {
            appInsights.trackException({
                exception: error,
                properties: { componentStack: info.componentStack },
                severityLevel: 3,
            });
        }
        console.error('[AppErrorBoundary]', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h2>Something went wrong.</h2>
                    <p>Please refresh the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default AppErrorBoundary;
